import React, { useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import styles from './Root.module.css';
import Header from '../Header';
import illustration from '../../assets/illustration5.svg';
import { getAuthToken } from '../../utils/auth';
import Lite_InjectScript from '../lite_injectScript';

const Root = () => {
  const history = useHistory();

  useEffect(() => {
    const authToken = getAuthToken();

    if (authToken) {
      history.push('/content');
    }
  }, []);

  return (
    <>
      <Lite_InjectScript />
      {/* 
      <Header />
      <div className={styles['root-banner']}>
        <div className={styles.content}>
          <h2 id={styles['root-banner__heading']}>Sign in with Fewcents to register</h2>
          <p id={styles['root-banner__cont']}>
            Register your publication with Fewcents in 2 easy steps to get started.
          </p>         
          <Link to="/register">
            <button type="button" id={styles['root-banner__button']}>
              Register now
            </button>
          </Link>
          <Link to="/login">
            <p id={styles['root-banner__signin']}>
              Already have an account? <span>Log in</span>.
            </p>
          </Link>
        </div>
        <div className={styles.illustration}>
          <img src={illustration} alt="illustration" />
        </div>
      </div>
      */}
    </>
  );
};

export default Root;
